

import { MessageModel } from 'app/models/messageModel'
import { MinimumWageConfigurationModel } from 'app/models/configuration/minimumWageConfigurationModel'
import { CountryModel } from 'app/models/timesheet/countryModel'

export type MinimumWageConfigurationStateProps = {
  companyId: string
  configuration: MinimumWageConfigurationModel
}

export type MinimumWageConfigurationDispatchProps = {
  showMessage: (message: MessageModel) => void
  getMinimumWageConfiguration: (
    companyId: string,
  ) => Promise<MinimumWageConfigurationModel>
  saveMinimumWageConfiguration: (
    companyId: string,
    printout: MinimumWageConfigurationModel,
  ) => Promise<MinimumWageConfigurationModel>
}

export type MinimumWageConfigurationOwnProps = {
    companyId?: string;
}

export const COUNTRY_TABS: Array<CountryModel> = [
  { name: 'general', code: undefined, nationId: -1, id: '-1' },
  { name: 'poland', code: 'PL', nationId: 0, id: '0' },
  { name: 'austria', code: 'AT', nationId: 1, id: '1' },
  { name: 'belgium', code: 'BE', nationId: 2, id: '2' },
  { name: 'bulgaria', code: 'BG', nationId: 3, id: '3' },
  { name: 'croatia', code: 'HR', nationId: 4, id: '4' },
  { name: 'cyprus', code: 'CY', nationId: 5, id: '5' },
  { name: 'czechRepublic', code: 'CZ', nationId: 6, id: '6' },
  { name: 'danemark', code: 'DK', nationId: 7, id: '7' }, // @TODO: denmark
  { name: 'estonia', code: 'EE', nationId: 8, id: '8' },
  { name: 'finland', code: 'FI', nationId: 9, id: '9' },
  { name: 'france', code: 'FR', nationId: 10, id: '10' },
  { name: 'greece', code: 'GR', nationId: 11, id: '11' },
  { name: 'spain', code: 'ES', nationId: 12, id: '12' },
  { name: 'irland', code: 'IE', nationId: 13, id: '13' },
  { name: 'lithuania', code: 'LT', nationId: 14, id: '14' },
  { name: 'luxembourg', code: 'LU', nationId: 15, id: '15' },
  { name: 'latvia', code: 'LV', nationId: 16, id: '16' },
  { name: 'malta', code: 'MT', nationId: 17, id: '17' },
  { name: 'holland', code: 'NL', nationId: 18, id: '18' },
  { name: 'germany', code: 'DE', nationId: 19, id: '19' },
  { name: 'norway', code: 'NO', nationId: 20, id: '20' },
  { name: 'portugal', code: 'PT', nationId: 21, id: '21' },
  { name: 'romania', code: 'RO', nationId: 22, id: '22' },
  { name: 'slovakia', code: 'SK', nationId: 23, id: '23' },
  { name: 'slovenia', code: 'SI', nationId: 24, id: '24' },
  { name: 'switzerland', code: 'CH', nationId: 25, id: '25' },
  { name: 'sweden', code: 'SE', nationId: 26, id: '26' },
  { name: 'hungary', code: 'HU', nationId: 27, id: '27' },
  { name: 'uk', code: 'GB', nationId: 28, id: '28' },
  { name: 'italy', code: 'IT', nationId: 29, id: '29' },
]

/** Kraje obsługiwane przez RestoreMinimumWageConfigurationRequestHandler. */
export const RESTORABLE_COUNTRIES: ReadonlySet<string> = new Set([
  'poland',
  'austria',
  'belgium',
  'danemark',
  'finland',
  'france',
  'holland',
  'luxembourg',
  'italy',
  'norway',
  'germany',
])
